import {
  SUPPORT_EMAIL,
  SUPPORT_TELEGRAM_CHAT_LINK,
} from "@js-app/const/config";
import { CompaniesApi } from "@js-app/office/api/companies-api";

class _SupportService {
  goToTelegramChat(target = "_blank") {
    window.open(SUPPORT_TELEGRAM_CHAT_LINK, target);
  }

  goToSupportPage(router, companyId) {
    router.push({
      name: "company-support",
      params: {
        id: companyId,
      },
    });
  }

  get SUPPORT_EMAIL() {
    return SUPPORT_EMAIL;
  }

  get AVAILABLE_JIRA_TOPICS() {
    return [
      {
        id: "suggestions",
        name: "support.jira-topics.suggestions",
      },
      {
        id: "bugs-errors",
        name: "support.jira-topics.bugs-errors",
      },
      {
        id: "other",
        name: "support.jira-topics.other",
      },
    ];
  }

  createJiraTicket(companyId, supportData) {
    const formData = new FormData();

    new Map(Object.entries(supportData)).forEach((_value, _key) =>
      formData.append(_key, _value)
    );

    return CompaniesApi.createJiraTicket(companyId, formData);
  }
}

export const SupportService = new _SupportService();
